import React from 'react';
import { Navigate } from 'react-router-dom';
import { AppContextWrapper, Portal, useAppSelector } from 'app';
import { Landing, Support, Costs } from 'app/layout';
import { getBootstrapApp } from 'app/redux';

export const AppLayoutWrapper: React.FC<{
  isLoggedIn: boolean;
}> = ({ isLoggedIn }) => {
  return isLoggedIn ? (
    <AppContextWrapper>
      <Portal />
    </AppContextWrapper>
  ) : (
    <Navigate to="/" />
  );
};

export const LandingLayoutWrapper: React.FC<{}> = () => {
  return (
    <AppContextWrapper>
      <Landing />
    </AppContextWrapper>
  );
};

export const SupportWrapper: React.FC<{
  isLoggedIn: boolean;
}> = ({ isLoggedIn }) => {
  return isLoggedIn ? (
    <AppContextWrapper>
      <Support />
    </AppContextWrapper>
  ) : (
    <Navigate to="/" />
  );
};

export const CostsWrapper: React.FC<{
  isLoggedIn: boolean;
}> = ({ isLoggedIn }) => {
  const { features } = useAppSelector(getBootstrapApp);

  return isLoggedIn && features.costs ? (
    <AppContextWrapper>
      <Costs />
    </AppContextWrapper>
  ) : (
    <Navigate to="/" />
  );
};
